import * as React from "react";
import { cn } from "../../lib/cn";

export const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-sm font-medium text-foreground inline-block",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";
